<i *ngIf="count === 0" class="pi pi-bell text-xl"></i>
<i *ngIf="count > 0 && count <= 200" class="pi pi-bell text-xl" pBadge [value]="count.toString()" severity="danger"></i>
<i *ngIf="count > 200" class="pi pi-bell text-xl" pBadge value="100+" severity="danger"></i>
